import script from "./GetHeaderMenu.vue?vue&type=script&lang=js"
export * from "./GetHeaderMenu.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__